import React from "react"
import Layout from "../components/layout"
import { graphql } from "gatsby"
import Gallery from '@browniebroke/gatsby-image-gallery'


const galleryPage = ({ data }) => {
  const gallery = data.prismicGalleryPage.data
  const images = gallery.images.map((obj) => obj.image)
  // `images` is an array of objects with `thumb` and `full`
  return (
  <Layout>
  <section className="gallery page">

  <div className="grid-x grid-padding-x down-2 bot-2">
    <div className="cell small-12 medium-8 medium-offset-2">
    <h1 className="down-half text-center">Gallery</h1>
  <div
      dangerouslySetInnerHTML={{
        __html: gallery.body.html,
      }}
    ></div>
    </div>
  </div>
  <div className="grid-x grid-padding-x bot-2">
  <div className="cell small-12 medium-10 medium-offset-1">

    <Gallery images={images} />

  </div>
  </div>
</section>
<section>
    <div className="grid-x grid-padding-x down-1 bot-3">
      <div className="cell small-12 medium-8 medium-offset-2">
        <h2 className="text-center">Video Tour Of Clarehouse</h2>
      <div className="video-responsive">
        <iframe
          width="853"
          height="480"
          src={`https://www.youtube.com/embed/${gallery.tour_video_embed_id.text}`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Youtube Video"
        />
      </div>
      </div>
    </div>
  </section>
  </Layout>
  )
}


export const pageQuery = graphql`
{
  prismicGalleryPage {
    data {
      body {
        html
      }
      tour_video_embed_id {
        text
      }
      images {
        caption {
          text
        }
        image {
              thumb:gatsbyImageData(width: 250, height: 250)
              full: gatsbyImageData(layout: FULL_WIDTH)
        }
      }
    }
  }
}

`

export default galleryPage
